import { throttle } from "lodash";

const menuTogger = document.querySelector('.header__menu-toggle');
const menuOverlay = document.querySelector('.header__overlay');
const header = document.querySelector('.header');
const fixedWrap = document.querySelector('.header__fixed-wrap');
const filter = document.querySelector('.filter');
const submenu = document.querySelector('.header__submenu');
const submenuLinks = document.querySelectorAll('.header__submenu .menu__link');
const body = document.querySelector('body');
const monthNames = document.querySelectorAll('.poster__month');
const merchNames = document.querySelectorAll('.merch__month');

const monthNamesA = document.querySelectorAll('.poster__month a:not(.poster__month-loyality-btn)');
const monthHovers = document.querySelectorAll('.poster-item.hover-list__item');

// попытка подделать скролл
monthNamesA.forEach((a) => {
  a.addEventListener("click", (e) => {
    console.log(a, "clicked");
    e.preventDefault();
    const felRect = document.getElementById(e.target.href.split('#')[1]).getBoundingClientRect(),
    bodyRect = document.body.getBoundingClientRect();
    let felOffset = felRect.top - bodyRect.top;

    window.scrollTo({ top: felOffset - (document.querySelector('.filter__menu') != null ? document.querySelector('.filter__menu').offsetHeight : 0) - (document.querySelector('.poster__month.state-top') != null ? document.querySelector('.poster__month.state-top').offsetHeight : 0), behavior: 'smooth' });

    // fel.classList.add('state-top');
    // let newtop = (fel.offsetTop - document.querySelector('.filter').offsetHeight - document.querySelector('.header__fixed-wrap').offsetHeight);

// element = document.getElementById('06.2026');
// const bodyRect = document.body.getBoundingClientRect(),
// let elemRect = element.getBoundingClientRect(),
// let offset   = elemRect.top - bodyRect.top;
window.scrollTo({top:offset});



    // console.log("wonna scroll to: ", newtop + "(" + fel.offsetTop + "-" + document.querySelector('.filter').offsetHeight + "-" + document.querySelector('.header__fixed-wrap').offsetHeight + ")");

    // window.scrollTo({ top: newtop, behavior: 'smooth' });
    // window.scrollTo({ top: newtop, behavior: 'smooth' });
    // return false;
  })
});


let lastScrollPosition = 0;
let sleepzone = 0;

export default function () {
  setActiveElement();

  window.addEventListener('load', function () {
    resizeHandler();

    header && window.addEventListener('resize', resizeHandler);
    header && window.addEventListener('scroll', throttle(updateHeaderPosition, 128), { passive: true });

    menuTogger && menuTogger.addEventListener('click', function () {
      header.classList.toggle('header--show');
    });

    menuOverlay && menuOverlay.addEventListener('click', function () {
      header.classList.toggle('header--show');
    });

    for (const submenuLink of submenuLinks) {
      submenuLink.addEventListener('click', (e) => {
        if (this.window.innerWidth < 1180) {
          if (submenuLink.classList.contains('active')) {
            e.preventDefault();

            submenu.classList.toggle('open');
          }
        }
      });
    }
  });
}

function resizeHandler() {
  sleepzone = fixedWrap.clientHeight * 2;

  setTimeout(updateHeaderPosition, 100);
}

function updateMonthNamesPostion() {
  monthNamesA.forEach((el) => {
    el.classList.remove('active');

  });
  for (const monthHover of monthHovers) {
    const top = monthHover.offsetTop - window.scrollY;
    if (top < screen.height && top > 0) {
      // console.log(monthHover.id, '0 >< ' + screen.height);
      // document.querySelectorAll(`.poster__month a[href:"#${monthHover.id}"]`)
      for (const monthName of monthNamesA) {
        // console.log(monthName.href, monthHover.id);
        if (monthName.href.indexOf('#' + monthHover.id) >= 0) {
          monthName.classList.add('active');
        }
      }
      break;
    }
  }
  let firstTop = null;
  for (const monthName of monthNames) {
    const top = monthName.offsetTop - window.scrollY;
    firstTop = firstTop || top;
    if (top == firstTop) {
      monthName.classList.add('state-top');
    } else {
      monthName.classList.remove('state-top');
    }
  }

}
function updateMerchNamesPostion() {
  let firstTop = null;
  for (const el of merchNames) {
    const top = el.offsetTop - window.scrollY;
    firstTop = firstTop || top;
    if (top == firstTop) {
      el.classList.add('state-top');
    } else {
      el.classList.remove('state-top');
    }
  }

}

function updateHeaderPosition() {
  requestAnimationFrame(() => {
    const newScrollPosition = window.scrollY;
    const isDirectionDown = lastScrollPosition < newScrollPosition;

    if (newScrollPosition < sleepzone) {
      header.classList.remove('header--down');
      header.classList.remove('header--up');
      header.classList.add('header--top');

      body.classList.remove('body--header-down');
      body.classList.remove('body--header-up');
      body.classList.add('body--header-top');

      filter && filter.classList.remove('filter--down');
    } else if (isDirectionDown && newScrollPosition) {
      header.classList.add('header--up');
      header.classList.remove('header--down');
      header.classList.remove('header--top');

      body.classList.add('body--header-up');
      body.classList.remove('body--header-down');
      body.classList.remove('body--header-top');

      filter && filter.classList.remove('filter--down');
    } else {
      header.classList.add('header--down');
      header.classList.remove('header--up');
      header.classList.remove('header--top');

      body.classList.add('body--header-down');
      body.classList.remove('body--header-up');
      body.classList.remove('body--header-top');

      filter && filter.classList.add('filter--down');
    }
    updateMonthNamesPostion();
    updateMerchNamesPostion();

    lastScrollPosition = newScrollPosition;
  });
}

function setActiveElement() {
  const noActiveGroups = document.querySelectorAll('.menu__list.active.no-active-item');

  for (const noActiveGroup of noActiveGroups) {
    let active;
    let link;
    let item;

    for (const menuItem of noActiveGroup.querySelectorAll('.menu__item')) {
      const allLink = menuItem.querySelector('.menu__link[href*="/all"]');

      if (allLink) {
        active = allLink;
        item = menuItem;
        link = allLink;

        break;
      }
    }

    if (!active) {
      item = noActiveGroup.querySelector('.menu__item');
      link = item.querySelector('.menu__link');
    }

    link && link.classList.add('active');
    item && item.classList.add('active');
  }
}
